<template>
<div class="popup" v-cloak v-if="nowPaySchemeShow">
    <div class="content" id="nowPayScheme">
        <div class="title">
            <span>{{$t('language.paySystem.nowPayScheme.manageYourPlan')}}</span>
            <div class="icon white-close dialog-close" @click="nowPaySchemeShow=false"></div>
        </div>
        <div class="now-scheme-body" v-loading="isLoading" element-loading-background="#fff" v-show="isLoading" style="height:calc(100% - 80px);"></div>
        <div class="now-scheme-body" v-if="!isLoading">
            <!-- 付费类型 -->
            <div class="cur_plan_item">
                <img src="../../../assets/images/paySystem/curPlanType.svg">
                <span>{{ $t('language.paySystem.supportItem.yourCurPlan') }}:</span>
                <div class="cur_plan_item_text">
                    <span>{{payInfo.payName + getInsCountStr()}}</span>
                    <div class="cur_plan_info">
                        <img src="../../../assets/images/paySystem/curPlanInfo.svg">
                        <div class="cur_plan_info_text">{{payInfo.payExtension}} {{ $t('language.paySystem.nowPayScheme.clearInsCountText') }}</div>
                    </div>
                </div>
            </div>
            <!-- 价格 -->
            <div class="cur_plan_item">
                <img src="../../../assets/images/paySystem/curPlanPrice.svg">
                <span>{{$t('language.paySystem.nowPayScheme.price')}}:</span>
                <div class="cur_plan_item_text">
                    <span>
                        <span class="price">{{payInfo.currency+payInfo.grossPrice}}</span>
                        <span class="old-price" v-if="payInfo.grossPrice!=payInfo.oldPrice">{{payInfo.currency+payInfo.oldPrice}}</span>
                        <span> , </span>
                        <span v-if="payInfo.vatPrice!=0" v-html="$t('language.paySystem.nowPayScheme.priceVat',{'currency':payInfo.currency,'vatPrice':payInfo.vatPrice,'percent':payInfo.percent,'netPrice':payInfo.netPrice})"></span>
                    </span>
                </div>
            </div>
            <!-- 信用卡 -->
            <div class="cur_plan_item">
                <img src="../../../assets/images/paySystem/curPlanCard.svg">
                <span>{{$t('language.paySystem.nowPayScheme.paymentMethon')}}:</span>
                <div class="cur_plan_item_text">
                    <span class="now-scheme-tips" v-if="payInfo.lastFourNumber" >{{$t('language.paySystem.nowPayScheme.defaultPayment',{"method":payInfo.payMethod,"num":payInfo.lastFourNumber})}}</span>
                    <span class="now-scheme-tips" v-else >{{$t('language.paySystem.nowPayScheme.paypalPayment')}}</span>
                    <img @click="openClick()" class="cur_plan_edit" src="../../../assets/images/paySystem/curPlanEdit.svg">
                </div>
            </div>
            <!-- 订阅状态 -->
            <div class="cur_plan_item">
                <img src="../../../assets/images/paySystem/curPlanAuto.svg">
                <span>{{$t('language.paySystem.nowPayScheme.autoRenewal')}}: {{ isSubscribe ? $t('language.twoStepverification.on') : $t('language.twoStepverification.off') }}</span>
                <div class="cur_plan_item_text">
                    <span v-if="isSubscribe">{{$t('language.paySystem.nowPayScheme.activated',{"time":(payInfo.nextPayTime)})}}</span>
                    <span v-if="!isSubscribe">{{$t('language.paySystem.nowPayScheme.deactivated',{"time":(payInfo.nextPayTime)})}}</span>
                    <div class="now-scheme-click cur_plan_item_a">
                        <span v-if="isSubscribe" @click="unsubscribePlan()">{{$t('language.common.unsubscribe')}}</span>
                        <span v-if="!isSubscribe" @click="reSubscription()">{{$t('language.common.reactivate')}}</span>
                    </div>
                </div>
            </div>
            <div class="now-scheme-close">
                <button style="border-radius: 5Px;" @click="nowPaySchemeShow=false">{{$t('language.common.ok')}}</button>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import getCurrencyUtils from '@/js/workspace/get_currency.js';
import commonstate from '@/js/constant.js';
import taskListUtils from "@/js/workspace/task_list_util.js";
export default {
    data() {
        return {
            insCount: null,
            nowPaySchemeShow: false,
            user: commonUtils.getUser(),
            payInfo: {
                payMethod: 'Visa',//支付方式
                lastFourNumber: '',//信用卡后四位
                changeUrl: '',//改变支付方式连接
                subId: '',//subsCriptionID
                netPrice: 0,//现在的价格
                oldPrice: 0,//以前的价格
            },
            isSubscribe: true,//是否订阅
            isLoading: true,//是否不显示内容
        }
    },
    mounted() {
        // 获取Ins个数
        taskListUtils.imageSaverRequest("/insCount", {}, res => {
            if (res.code == 200) {
                this.insCount = res.data;
            }
        });
    },
    methods: {
        // 拼接Ins个数字符串
        getInsCountStr() {
            if (this.insCount) {
                var total = this.insCount.total;
                if (total == 0) {
                    return ' + ' + this.$t('language.paySystem.supportItem.unlimitedInsProfile');
                } else if (total == 10) {
                    return ' + ' + this.$t('language.paySystem.supportItem.ins10');
                } else if (total == 20) {
                    return ' + ' + this.$t('language.paySystem.supportItem.ins20');
                } else if (total == 120 || total == 12) {
                    return ' + ' + this.$t('language.paySystem.supportItem.ins120');
                } else if (total == 240 || total == 24) {
                    return ' + ' + this.$t('language.paySystem.supportItem.ins240');
                }
            }
            return ' + ' + this.$t('language.paySystem.supportItem.ins10');
        },
        getPayInfo () {
            var self = this;
            this.Utils.doSubinquiryPostRequest('get_by_purchaseIdV', { purchaseId: self.payInfo.purchaseId }).then(res => {
                //如果请求成功
                if (res.ResultMessage == 'OK') {
                    let json = JSON.parse(res.PurchaseNotification);

                    self.payInfo.changeUrl = json.items[0].recurringBilling.changePaymentSubscriptionUrl;
                    self.payInfo.cancelUrl = json.items[0].recurringBilling.cancellationUrl;

                    self.payInfo.purchaseId = json.purchaseId;
                    self.payInfo.payName = json.items[0].productName;
                    self.payInfo.payExtension = json.items[0].productNameExtension;
                    //购买时价格
                    let currencyId = json.paymentInfo.currencyId;
                    self.payInfo.currency = getCurrencyUtils.getCurrencyByCurrencyId(currencyId);
                    self.payInfo.oldPrice = commonUtils.initPriceFormat(currencyId,json.items[0].customerPrice.productSinglePrice.grossPrice);
                    self.payInfo.grossPrice = commonUtils.initPriceFormat(currencyId,json.items[0].customerPrice.totalSinglePrice.grossPrice);
                    let netPrice = json.items[0].customerPrice.totalSinglePrice.netPrice;
                    let vatPrice = json.items[0].customerPrice.totalSinglePrice.vatPrice;
                    self.payInfo.netPrice = commonUtils.initPriceFormat(currencyId,netPrice);
                    self.payInfo.vatPrice = commonUtils.initPriceFormat(currencyId,vatPrice);
                    self.payInfo.percent = ((vatPrice / netPrice) * 100);
                    self.payInfo.percent = self.payInfo.percent.toFixed(2);
                    //临时处理円改为￥
                    if(self.payInfo.currency=="円"){
                        self.payInfo.currency= "￥";
                    }

                    //是否续订
                    if(json.items[0].recurringBilling.statusId == "ACT"){
                        self.isSubscribe = true;
                    }else{
                        self.isSubscribe = false;
                    }
                    //显示内容
                    self.isLoading = false;
                }
            });
        },
        openClick () {
            if (this.payInfo.changeUrl) {
                window.open(this.payInfo.changeUrl, '_blank');
                this.diffShow = false;
                this.$parent.getUserStatus();
            }
        },
        //取消订阅
        unsubscribePlan() {
            //取消paypel订阅
            if(this.$parent.user.subscrId!=null && this.$parent.user.subscrId.startsWith("I")){
                window.open('https://www.paypal.com/cgi-bin/webscr?cmd=_subscr-find&alias=49QKC8T9BTJDC');
                this.$parent.getUserStatus(); //开始检测用户的状态
                return;
            }  
            //cb关闭和重新订阅共用同一方式
            this.reSubscription();
        },
        reSubscription () {
            // 取得要提交页面的URL
            var action = this.payInfo.cancelUrl;
            commonUtils.packageFormAndSubmit(action, this.payInfo, this.$parent.user);
            this.$parent.getUserStatus(); //开始检测用户的状态
        },
    }
}
</script>

<style>
#nowPayScheme {
    width: 540px;
    /*no*/
    height: 416px;
    /*no*/
}

.now-scheme-body{
    padding: 20Px;
    display: grid;
}

.now-scheme-msg{
    display: flex;
    margin-bottom: 10Px;
}

.now-scheme-msg-left{
    width: 60%;
    float: left;
    display: grid;
}

.now-scheme-msg-right{
    width: 40%;
    float: right;
    display: grid;
    text-align: right;
    padding-right: 20Px;
}

.now-scheme-name{
    color: #333333;
    font-size: 16Px;
    font-weight: 700;
    line-height: 20Px;
}

.now-scheme-tip{
    color: #6f6f6f;
    font-size: 14Px;
    line-height: 22Px;
}

.now-scheme-price{
    line-height: 33Px;
}

.now-scheme-price .price{
    font-size: 30Px;
    color: #5562b4;
}

.now-scheme-price .old-price{
    color: #b8bee6;
    position: unset;
    float: unset;
}

.now-scheme-vat{
    font-size: 14Px;
    color: #a3adbd;
    line-height: 20Px;
}

.now-scheme-mid {
    display: grid;
    line-height: 22Px;
    font-size: 14Px;
    margin: 10Px 0;
}

.now-scheme-mid .now-scheme-tips{
    color: #333333;
}

.now-scheme-mid .now-scheme-click span{
    color: #5562b4;
    cursor: pointer;
}

.now-scheme-mid .now-scheme-click span:hover{
    text-decoration: underline;
}

.now-scheme-close{
    position: absolute;
    bottom: 20Px;
    right: 20Px;
}

.now-scheme-close button{
    width: 110Px;
    height: 30Px;
    background: #5562B4;
}

#nowPayScheme .title{
    height: 40px;
    line-height: 40px;
    background: #5562B4 !important;
}

/* 新的样式 */
.cur_plan_item {
    margin-bottom: 30px;
}
.cur_plan_item>img {
    vertical-align: middle;
    margin-right: 1px;
}
.cur_plan_item>span {
    vertical-align: middle;
    height: 18px;
    line-height: 18px;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
}
.cur_plan_item_text {
    height: 16px;
    line-height: 16px;
    font-size: 14px;
    color: #333333;
    text-indent: 22px;
    margin-top: 5px;
}
.cur_plan_info {
    display: inline-block;
    text-indent: 0px;
    vertical-align: middle;
    margin-left: 10px;
    position: relative;
}
.cur_plan_info_text {
    display: none;
    position: absolute;
    z-index: 1;
    left: 20px;
    top: 0px;
    background-color: #FFF;
    border: 1px solid #8A96E3;
    width: 280px;
    padding: 10px;
    border-radius: 4px;
}
.cur_plan_info:hover>.cur_plan_info_text {
    display: block;
}
.cur_plan_edit {
    cursor: pointer;
}
.cur_plan_item_a {
    color: #5562B4;
    font-size: 14px;
    text-decoration: underline;
    cursor: pointer;
    display: inline-block;
    text-indent: 0px;
    margin-left: 10px;
}
.old-price{
    color: #BDBDBD;
    text-decoration: line-through;
    float: none;
    margin-left: 0px;
    top: 0px;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/pay_system_popups/now_pay_scheme_popups.vue